(function () {
  var current = null;

  function init() {
    var root = document.querySelector('[data-lmds-nl]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var dialog = root.querySelector('[data-lmds-nl-dialog]');
    var panel = dialog.querySelector('.lmds-nl__panel');
    var teaser = root.querySelector('[data-lmds-nl-teaser]');
    var form = dialog.querySelector('form');
    var input = form.querySelector('input[type="email"]');
    var errorEl = form.querySelector('[data-lmds-nl-error]');
    var submitBtn = form.querySelector('[data-lmds-nl-submit]');
    var copyBtn = dialog.querySelector('[data-lmds-nl-copy]');

    var cfg = {
      delay: (parseInt(root.dataset.delay, 10) || 20) * 1000,
      days: parseInt(root.dataset.days, 10) || 7,
      code: root.dataset.code || '',
      auto: root.dataset.auto === 'true',
      autoApply: root.dataset.autoApply === 'true',
      design: root.dataset.design === 'true',
      klaviyoCompany: root.dataset.klaviyoCompany || '',
      klaviyoList: root.dataset.klaviyoList || ''
    };

    var KEY = {
      subscribed: 'lmds-nl-subscribed',
      dismissed: 'lmds-nl-dismissed-at',
      start: 'lmds-nl-session-start',
      shown: 'lmds-nl-auto-shown',
      teaser: 'lmds-nl-teaser-hidden',
      pending: 'lmds-nl-pending'
    };

    function storage(type) {
      try {
        return window[type];
      } catch (e) {
        return null;
      }
    }

    function get(type, key) {
      try {
        var s = storage(type);
        return s ? s.getItem(key) : null;
      } catch (e) {
        return null;
      }
    }

    function set(type, key, value) {
      try {
        var s = storage(type);
        if (!s) return;
        if (value === null) s.removeItem(key);
        else s.setItem(key, value);
      } catch (e) {}
    }

    var DAY = 86400000;
    var closeTimer = null;

    function isSubscribed() {
      return get('localStorage', KEY.subscribed) === '1';
    }

    function recentlyDismissed() {
      var at = parseInt(get('localStorage', KEY.dismissed), 10);
      return at && Date.now() - at < cfg.days * DAY;
    }

    function showTeaser() {
      if (!teaser || dialog.open) return;
      if (!cfg.design && (isSubscribed() || get('sessionStorage', KEY.teaser) === '1')) return;
      teaser.hidden = false;
      requestAnimationFrame(function () {
        teaser.classList.add('is-visible');
      });
    }

    function hideTeaser() {
      if (!teaser) return;
      teaser.classList.remove('is-visible');
    }

    function open(state) {
      if (dialog.open) return;
      clearTimeout(closeTimer);
      if (state) panel.dataset.state = state;
      dialog.classList.remove('is-closing');
      try {
        dialog.showModal();
      } catch (e) {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('lmds-nl-lock');
      hideTeaser();
      panel.focus({ preventScroll: true });
    }

    function close(remember) {
      if (!dialog.open) return;
      if (remember !== false && panel.dataset.state !== 'success') {
        set('localStorage', KEY.dismissed, String(Date.now()));
      }
      dialog.classList.remove('is-instant');
      dialog.classList.add('is-closing');
      var finish = function () {
        dialog.classList.remove('is-closing');
        if (dialog.open) dialog.close();
        document.documentElement.classList.remove('lmds-nl-lock');
        if (!isSubscribed()) showTeaser();
      };
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      closeTimer = setTimeout(finish, reduce ? 0 : 320);
    }

    function otherLayerOpen() {
      var dialogs = document.querySelectorAll('dialog[open]');
      for (var i = 0; i < dialogs.length; i++) {
        if (dialogs[i] !== dialog) return true;
      }
      var active = document.activeElement;
      if (active && /^(INPUT|TEXTAREA|SELECT)$/.test(active.tagName) && !dialog.contains(active)) return true;
      return false;
    }

    function scheduleAuto() {
      if (cfg.design || !cfg.auto || isSubscribed() || recentlyDismissed()) return;
      if (get('sessionStorage', KEY.shown) === '1') return;
      var start = parseInt(get('sessionStorage', KEY.start), 10);
      if (!start) {
        start = Date.now();
        set('sessionStorage', KEY.start, String(start));
      }
      var wait = Math.max(cfg.delay - (Date.now() - start), 1500);
      var attempt = function () {
        if (isSubscribed() || recentlyDismissed() || dialog.open) return;
        if (document.hidden || otherLayerOpen()) {
          setTimeout(attempt, 5000);
          return;
        }
        set('sessionStorage', KEY.shown, '1');
        open('form');
      };
      setTimeout(attempt, wait);
    }

    function showError(message) {
      errorEl.textContent = message;
      input.setAttribute('aria-invalid', 'true');
    }

    function clearError() {
      errorEl.textContent = '';
      input.removeAttribute('aria-invalid');
    }

    function applyDiscount() {
      if (!cfg.autoApply || !cfg.code) return;
      fetch('/discount/' + encodeURIComponent(cfg.code), { credentials: 'same-origin' }).catch(function () {});
    }

    function success() {
      set('localStorage', KEY.subscribed, '1');
      set('localStorage', KEY.dismissed, null);
      set('sessionStorage', KEY.pending, null);
      applyDiscount();
      panel.dataset.state = 'success';
      if (teaser) teaser.hidden = true;
      panel.focus({ preventScroll: true });
    }

    function cleanUrl() {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('customer_posted');
        url.hash = '';
        window.history.replaceState(null, '', url.pathname + url.search);
      } catch (e) {}
    }

    form.addEventListener(
      'submit',
      function (event) {
        clearError();
        var email = input.value.trim();
        input.value = email;
        if (!email || !input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          showError('Merci de saisir une adresse e-mail valide.');
          input.focus();
          return;
        }
        set('sessionStorage', KEY.pending, '1');
        submitBtn.classList.add('is-loading');
      },
      true
    );

    var busy = false;

    function subscribeKlaviyo(email) {
      return window
        .fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(cfg.klaviyoCompany), {
          method: 'POST',
          headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Pop-up -10 % site',
                profile: { data: { type: 'profile', attributes: { email: email } } }
              },
              relationships: { list: { data: { type: 'list', id: cfg.klaviyoList } } }
            }
          })
        })
        .then(function (res) {
          if (!res.ok) throw new Error(String(res.status));
        });
    }

    function shopifySubmit() {
      set('sessionStorage', KEY.pending, '1');
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else HTMLFormElement.prototype.submit.call(form);
    }

    function handleSubmit() {
      if (busy) return;
      clearError();
      var email = input.value.trim();
      input.value = email;
      if (!email || !input.checkValidity()) {
        showError('Merci de saisir une adresse e-mail valide.');
        input.focus();
        return;
      }
      if (!cfg.klaviyoCompany || !cfg.klaviyoList || !window.fetch) {
        shopifySubmit();
        return;
      }
      busy = true;
      submitBtn.classList.add('is-loading');
      subscribeKlaviyo(email)
        .then(function () {
          busy = false;
          submitBtn.classList.remove('is-loading');
          success();
        })
        .catch(function () {
          busy = false;
          shopifySubmit();
        });
    }

    submitBtn.addEventListener('click', function (event) {
      event.preventDefault();
      handleSubmit();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      handleSubmit();
    });

    input.addEventListener('invalid', function (event) {
      event.preventDefault();
      showError('Merci de saisir une adresse e-mail valide.');
      input.focus();
    });

    input.addEventListener('input', function () {
      if (errorEl.textContent) clearError();
    });

    if (copyBtn) {
      var copyLabel = copyBtn.textContent;
      copyBtn.addEventListener('click', function () {
        var done = function () {
          copyBtn.textContent = copyBtn.dataset.labelDone || copyLabel;
          copyBtn.classList.add('is-done');
          setTimeout(function () {
            copyBtn.textContent = copyLabel;
            copyBtn.classList.remove('is-done');
          }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(cfg.code).then(done, done);
        } else {
          var range = document.createRange();
          range.selectNodeContents(dialog.querySelector('[data-lmds-nl-code]'));
          var sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
          try {
            document.execCommand('copy');
          } catch (e) {}
          done();
        }
      });
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-lmds-nl-open]')) {
        open(isSubscribed() ? 'success' : 'form');
        return;
      }
      if (event.target.closest('[data-lmds-nl-teaser-hide]')) {
        set('sessionStorage', KEY.teaser, '1');
        hideTeaser();
        return;
      }
      if (event.target.closest('[data-lmds-nl-close]')) {
        close();
      }
    });

    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var r = panel.getBoundingClientRect();
      var inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!inside) close();
    });

    dialog.addEventListener('cancel', function (event) {
      event.preventDefault();
      close();
    });

    var pending = get('sessionStorage', KEY.pending) === '1';
    var serverError = errorEl.textContent.trim();
    if (pending && (form.querySelector('[data-lmds-nl-posted]') || /déjà|already|taken|utilisé/i.test(serverError))) {
      clearError();
      success();
      open('success');
      cleanUrl();
    } else if (pending && serverError) {
      set('sessionStorage', KEY.pending, null);
      open('form');
      cleanUrl();
    } else if (window.location.hash === '#lmds-newsletter') {
      open(isSubscribed() ? 'success' : 'form');
    }
    if (pending && panel.dataset.state !== 'success' && !serverError) {
      set('sessionStorage', KEY.pending, null);
    }

    document.addEventListener('lmds:subscribed', function () {
      if (teaser) {
        hideTeaser();
        teaser.hidden = true;
      }
    });

    showTeaser();
    scheduleAuto();

    current = {
      id: root.dataset.sectionId,
      open: function () {
        open(isSubscribed() && !cfg.design ? 'success' : panel.dataset.state || 'form');
      },
      close: function () {
        close(false);
      }
    };
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href$="#lmds-newsletter"]');
    if (!link || !current) return;
    event.preventDefault();
    current.open();
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-lmds-nl]')) init();
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (current && event.detail && event.detail.sectionId === current.id) current.open();
  });

  document.addEventListener('shopify:section:deselect', function (event) {
    if (current && event.detail && event.detail.sectionId === current.id) current.close();
  });

  init();
})();
